var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path9, _path10, _path11, _path12, _path13, _path14, _line3, _line4, _rect11, _rect12, _rect13, _path15, _rect14, _rect15, _rect16, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.387 217.985L340.875 132.04C340.802 130.847 341.568 128.638 345.22 129.354L516.956 129.354C518.722 128.981 522.92 129.534 525.584 134.726L569.498 195.156C570.85 197.021 574.373 200.751 577.644 200.751L634.649 200.751",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.161 218.209L295.65 132.183C295.737 130.988 294.995 128.777 291.332 129.494L119.459 129.494C117.696 129.121 113.488 129.674 110.763 134.872L66.1273 195.373C64.7527 197.24 61.1847 200.975 57.911 200.975L0.860771 200.975",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.607 316.911L294.566 324.073C294.64 325.117 294.164 327.206 291.662 327.206L221.669 327.206C221.028 327.206 219.271 325.953 217.375 320.94C216.959 319.838 215.001 315.017 212.022 307.735M0.742898 221.79L20.8268 221.79M138.145 189.784L138.124 193.365L138.166 185.979M138.145 189.784L149.51 189.784M138.145 189.784L126.78 189.784M149.51 189.784L160.874 189.784C162.991 189.784 164.469 192.172 164.943 193.365C175.147 218.091 191.768 258.404 203.576 287.144M149.51 189.784L149.489 193.365L149.531 185.979M126.78 189.784L115.415 189.784C113.973 189.635 110.41 190.142 107.698 193.365L97.1644 205.787M126.78 189.784L126.759 193.365L126.801 185.979M97.1644 205.787L86.631 218.209C85.4216 219.402 82.618 221.79 81.0786 221.79L60.9947 221.79M97.1644 205.787L107.627 205.787L86.7015 205.787M40.9107 221.79L40.8841 226.49M40.9107 221.79L60.9947 221.79M40.9107 221.79L20.8268 221.79M60.9947 221.79L60.968 226.49M20.8268 221.79L20.8001 226.49M212.022 307.735L223.704 307.735M212.022 307.735C210.78 304.7 209.362 301.238 207.803 297.439M207.803 297.439L223.762 297.439M207.803 297.439C206.486 294.229 205.07 290.779 203.576 287.144M203.576 287.144L223.821 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.834 316.911L339.793 324.073C339.707 325.117 340.16 327.206 342.662 327.206L412.655 327.206C413.296 327.206 415.067 325.953 417.02 320.94C417.449 319.838 419.462 315.017 422.523 307.735M634.778 221.79L614.694 221.79M497.739 189.784L497.719 193.365L497.761 185.979M497.739 189.784L486.375 189.784M497.739 189.784L509.104 189.784M486.375 189.784L475.01 189.784C472.893 189.784 471.388 192.172 470.9 193.365C460.416 218.091 443.337 258.404 431.203 287.144M486.375 189.784L486.354 193.365L486.396 185.979M509.104 189.784L520.469 189.784C521.913 189.635 525.47 190.142 528.146 193.365L538.538 205.787M509.104 189.784L509.084 193.365L509.126 185.979M538.538 205.787L548.93 218.209C550.126 219.402 552.903 221.79 554.442 221.79L574.526 221.79M538.538 205.787L528.075 205.787L549.001 205.787M594.61 221.79L594.583 226.49M594.61 221.79L574.526 221.79M594.61 221.79L614.694 221.79M574.526 221.79L574.499 226.49M614.694 221.79L614.667 226.49M422.523 307.735L410.841 307.735M422.523 307.735C423.799 304.7 425.257 301.238 426.859 297.439M426.859 297.439L410.9 297.439M426.859 297.439C428.212 294.229 429.668 290.779 431.203 287.144M431.203 287.144L410.958 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.351 201.87L319.357 24.6092C319.361 23.8631 319.85 22.371 321.775 22.371L524.057 22.371C526.302 22.4456 530.795 21.8339 530.812 18.79C530.829 15.7461 530.875 7.6739 530.896 4.01826C530.821 3.12301 531.248 1.33249 533.557 1.33249L625.508 0.999998",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.843 201.87L318.346 113.24L318.849 24.6092C318.854 23.8631 318.382 22.371 316.46 22.371L114.485 22.371C112.243 22.4456 115.855 21.6537 115.873 18.6099C115.89 15.566 115.936 7.49375 115.956 3.83812C116.042 2.94286 107.544 1.33249 105.238 1.33249L11.0216 1.15234",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.599 337.726L317.554 345.783C317.382 347.723 318.098 351.602 322.331 351.602L497.194 351.602C498.476 351.751 501.96 350.886 505.643 346.231L563.297 274.162C564.346 272.894 566.878 270.357 568.61 270.357L634.274 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.598 337.726L316.552 345.783C316.701 347.723 315.942 351.602 311.708 351.602L136.846 351.602C135.562 351.751 132.088 350.886 128.458 346.231L71.6219 274.162C70.5868 272.894 68.0837 270.357 66.3519 270.357L0.688286 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 537.766 22.5947)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 2.35449 22.595)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.7721,
    transform: "matrix(-0.00364558 0.999993 -0.999957 -0.00932152 224.555 285.586)",
    fill: "url(#paint0_linear_439_919)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.7721,
    transform: "matrix(-0.00364549 0.999993 0.999998 -0.00203057 410.782 286.265)",
    fill: "url(#paint1_linear_439_919)",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 16.772,
    transform: "matrix(-0.00364558 0.999993 -0.999957 -0.00932152 224.515 296.625)",
    fill: "url(#paint2_linear_439_919)",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 16.772,
    transform: "matrix(-0.00364549 0.999993 0.999998 -0.00203057 410.742 297.304)",
    fill: "url(#paint3_linear_439_919)",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12125,
    height: 9.0385,
    transform: "matrix(0.999978 0.00517778 0.00256667 -0.999991 291.439 254.932)",
    fill: "url(#paint4_linear_439_919)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12126,
    height: 10.4152,
    transform: "matrix(0.999969 0.00596636 -0.00222741 0.99999 291.412 265.477)",
    fill: "url(#paint5_linear_439_919)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12125,
    height: 15.0642,
    transform: "matrix(0.999978 0.00517778 0.00256667 -0.999991 316.894 255.064)",
    fill: "url(#paint6_linear_439_919)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12126,
    height: 17.3586,
    transform: "matrix(0.999969 0.00596636 -0.00222741 0.99999 316.866 265.629)",
    fill: "url(#paint7_linear_439_919)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12125,
    height: 9.0385,
    transform: "matrix(0.999978 0.00517778 0.00256667 -0.999991 340.227 255.185)",
    fill: "url(#paint8_linear_439_919)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12126,
    height: 10.4152,
    transform: "matrix(0.999969 0.00596636 -0.00222741 0.99999 340.199 265.768)",
    fill: "url(#paint9_linear_439_919)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106 141.5L110.5 135C111.167 133.167 114 129.5 120 129.5C126 129.5 136.5 129.5 141 129.5",
    stroke: "url(#paint10_linear_439_919)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M531 141.5L526.5 135C525.834 133.167 523 129.5 517 129.5C511 129.5 500.5 129.5 496 129.5",
    stroke: "url(#paint11_linear_439_919)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 221.5L166 196C164.4 190 161.333 189.5 160 190H149.5M149.5 190L149.5 186.5M149.5 190L149.5 193.5",
    stroke: "url(#paint12_linear_439_919)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M459 221.5L469.501 196C471.101 190 474.168 189.5 475.501 190H486M486 190L486 186.5M486 190L486 193.5",
    stroke: "url(#paint13_linear_439_919)",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130 348C130.834 349.167 133.4 351.5 137 351.5C140.601 351.5 152.501 351.5 158 351.5",
    stroke: "url(#paint14_linear_439_919)",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M504 348C503.167 349.167 500.601 351.5 497 351.5C493.4 351.5 481.5 351.5 476 351.5",
    stroke: "url(#paint15_linear_439_919)",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 196,
    y1: 23,
    x2: 245,
    y2: 23,
    stroke: "url(#paint16_linear_439_919)",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 49,
    y2: -1,
    transform: "matrix(-1 0 -1.20026e-10 1 442 24)",
    stroke: "url(#paint17_linear_439_919)",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.019 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 605.094 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 590.169 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M575.241 193.664C575.244 193.252 575.58 192.918 575.992 192.918L584.318 192.918C585.423 192.918 586.313 193.813 586.307 194.918L586.303 195.549C586.298 196.568 585.467 197.394 584.447 197.394L578.95 197.394C576.89 197.394 575.23 195.724 575.241 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 16.312 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 31.2363 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 46.1606 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0807 193.664C61.0831 193.252 60.7509 192.918 60.3389 192.918L52.0122 192.918C50.9076 192.918 50.0071 193.813 50.0009 194.918L49.9973 195.549C49.9915 196.568 50.813 197.394 51.8323 197.394L57.3293 197.394C59.3894 197.394 61.069 195.724 61.0807 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_919",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_439_919",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_439_919",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 16.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_439_919",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 16.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_439_919",
    x1: 1.06062,
    y1: 9.0385,
    x2: 1.06062,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_439_919",
    x1: 1.06063,
    y1: 10.4152,
    x2: 1.06063,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_439_919",
    x1: 1.06062,
    y1: 15.0642,
    x2: 1.06062,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_439_919",
    x1: 1.06063,
    y1: 17.3586,
    x2: 1.06063,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_439_919",
    x1: 1.06062,
    y1: 9.0385,
    x2: 1.06062,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_439_919",
    x1: 1.06063,
    y1: 10.4152,
    x2: 1.06063,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_439_919",
    x1: 108.02,
    y1: 140.75,
    x2: 138.764,
    y2: 127.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_439_919",
    x1: 528.981,
    y1: 140.75,
    x2: 498.237,
    y2: 127.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_439_919",
    x1: 160.952,
    y1: 219.522,
    x2: 177.934,
    y2: 218.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_439_919",
    x1: 474.549,
    y1: 219.522,
    x2: 457.567,
    y2: 218.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_439_919",
    x1: 131.616,
    y1: 351.281,
    x2: 143.992,
    y2: 336.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_439_919",
    x1: 502.385,
    y1: 351.281,
    x2: 490.009,
    y2: 336.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_439_919",
    x1: 196,
    y1: 24.5,
    x2: 245,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_439_919",
    x1: 0,
    y1: 0.5,
    x2: 49,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame10);
export default __webpack_public_path__ + "static/media/card1-frame10.cd49ff3648fa082f30796f9580d4e9a5.svg";
export { ForwardRef as ReactComponent };